import '../resources/css/information.css';
import Accordion from './Accordion';
import List from './shared/List';
import Separator from './shared/Separator';

export default function Information({ data }) {

    const { title, background, isEnabled, conclusion, accordion, list } = data;

    if (!isEnabled) { return <div></div> };

    return (
        <div className="information" style={{ backgroundImage: `url(${background})` }}>

            <div className="title-h1">{title}</div>

            <Separator className="color-purple"></Separator>

            <div className="information-content">
                <div>
                    {accordion && <Accordion {...accordion}></Accordion>}
                </div>
                <div>
                    {list && <List {...list}></List>}
                </div>
            </div>

            {conclusion && <p className="information-conclusion color-purple">{conclusion}</p>}

        </div >);
};